export default __webpack_public_path__ + "static/night_ctaModule_table_mobile-524142dcb8082a00126fcc4e6c2001a3.png";